import { useState, useEffect, Fragment } from 'react';
import {useTranslation} from 'react-i18next';

import useFetch from '../../../../../hooks/use-fetch';
import HtmlInput from '../../../../UI/HtmlInput';

const RequestCode = (props) => {
  const {t: translate } = useTranslation();
  const {
    data: forgotPassData,
    loading,
    error: fetchErrors,
    initFunc: requestCode,
  } = useFetch();
  const { apiUrl } = window['appConfig'];

  const requestFields = {
    email: '',
  };

  const [requestValues, setRequestValues] = useState(requestFields);
  const [requestErrors, setRequestErrors] = useState({});
  const [canSubmit, setCanSubmit] = useState(false);
  const [forgotPassErrors, setForgotPassErrors] = useState('');

  const handleRequestChange = (e) => {
    const { name, value } = e.target;

    setRequestValues({
      ...requestValues,
      [name]: value,
    });
  };

  const handleRequestSubmit = async (e) => {
    e.preventDefault();

    //remove all errors
    setRequestErrors({});
    setForgotPassErrors();

    if (!requestValues.email) {
      setRequestErrors((prevState) => ({
        ...prevState,
        email: translate('email-required'),
      }));
    }

    setCanSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(requestErrors).length === 0 && canSubmit === true) {
      const formBody = Object.keys(requestValues)
        .map(
          (key) =>
            encodeURIComponent(key) +
            '=' +
            encodeURIComponent(requestValues[key]),
        )
        .join('&');

      const forgotPassOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody,
      };

      requestCode({
        url: `${apiUrl}/user/forgotpassword`,
        options: forgotPassOptions,
      });
    }
  }, [canSubmit]);

  useEffect(() => {
    setCanSubmit(false);
    if (fetchErrors !== null) {
      setForgotPassErrors(fetchErrors);
    }

    if (forgotPassData !== null && fetchErrors === null) {
      props.updateState('details');
      props.setEmail(requestValues.email);
    }
  }, [forgotPassData, fetchErrors]);

  return (
    <Fragment>
      <h4 className="input-container__heading">{translate('forgotten-password')}</h4>
      <p className="input-container__description">{translate('forgot-password-text')}</p>
      <form onSubmit={handleRequestSubmit}>
        <div
          className={`input-row ${
            requestErrors.email ? 'input-row--error' : ''
          }`}
        >
          <HtmlInput
            type='email'
            id='email'
            name="email"
            legend={translate('email')}
            value={requestValues.email}
            changeCallback={handleRequestChange}
            hasErrors={'email' in requestErrors}
          />
          {requestErrors.email && (
            <p className="input-row__error">{requestErrors.email}</p>
          )}
        </div>
        <button
          className={`button ${loading ? 'button--loading' : ''}`}
          disabled={loading ? true : false}
        >
          <span>
            {loading ? translate('sending-instructions') : translate('reset-password')}
          </span>
        </button>
        <p className="input-row__error input-row--centre input-row--mt">
          {forgotPassErrors}
        </p>
      </form>
    </Fragment>
  );
};

export default RequestCode;
